import InputGroupAddon, { propsFactory } from './input-group-addon';

export default {
  functional: true,
  props: propsFactory(true),
  render: InputGroupAddon.render
};


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/es/components/input-group/input-group-append.js
// module id = 704
// module chunks = 0